import { Middleware } from '@reduxjs/toolkit';
import { showGlobalError, clearGlobalError } from '../slices/uiSlice';

// Centralized error middleware: listens for any rejected async thunk
// and surfaces a user-friendly message in a global error banner.
// Additionally, closes the banner on any successful async thunk to keep UI fresh.
export const errorMiddleware: Middleware = ({ dispatch }) => (next) => (action: any) => {
  // Pass action through first so reducers can update their own error states if needed
  const result = next(action);

  try {
    if (typeof action?.type === 'string') {
      if (action.type.endsWith('/rejected')) {
        // Prefer explicit payload from rejectWithValue
        const fromPayload = typeof action.payload === 'string' ? action.payload : undefined;
        const fromError = action.error?.message as string | undefined;

        // If the payload includes very technical HTML or is empty, use a safe generic
        const pick = fromPayload || fromError || 'An issue has occurred, try again later';
        const looksLikeHtml = /<[^>]+>/.test(pick) || /<!DOCTYPE/i.test(pick);
        const message = looksLikeHtml ? 'An issue has occurred, try again later' : pick;

        // Dispatch global error banner
        dispatch(showGlobalError(message));
      } else if (action.type.endsWith('/fulfilled')) {
        // Only clear on successful completion.
        dispatch(clearGlobalError());
      }
    }
  } catch (e) {
    // Swallow middleware errors to avoid breaking the app (no console noise)
  }

  return result;
};
